import { API_SUCCESS, API_FAIL } from "./actionTypes"

const INIT_STATE = {
  chartsData: [],
}

const Dashboard = (state = INIT_STATE, action) => {
  switch (action.type) {
    default:
      return state
  }
}

export default Dashboard
